module.exports = __webpack_public_path__ + "img/chat.c61fd4b4.svg";